import { render, staticRenderFns } from "./SdsHmisLabel.vue?vue&type=template&id=5d947abc&"
import script from "./SdsHmisLabel.vue?vue&type=script&lang=js&"
export * from "./SdsHmisLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports